/**
 * booking-lifecycle.js
 * ----------------------
 * Every booking step follows the same shape:
 *
 *   Page opens -> Load Booking State -> Validate/Render -> Handle
 *   interaction -> Save Booking State -> Navigate
 *
 * This file is the one place that shape lives, so the two step pages
 * can't quietly drift into different init orderings again (which is how
 * the empty-state flash and a stale-state race were introduced before).
 *
 * Concretely, BookingLifecycle.run(options):
 *
 *   1. Loads the current Booking State (if booking-state.js is present).
 *   2. Calls the page's `render(state)` hook synchronously, so the page
 *      decides what to show *before* anything is revealed.
 *   3. Reveals the root element only after that render call returns. The
 *      root element must start with the `hidden` attribute in the Liquid
 *      markup — this function is the only place that removes it, which is
 *      what eliminates the empty-state flash.
 *   4. Optionally re-runs the render hook whenever Booking State changes
 *      elsewhere (another tab/page/section), via `reactive: true`.
 */
(function (window) {
  'use strict';

  function run(options) {
    options = options || {};
    var root = options.root;
    if (!root) return;

    function currentState() {
      return (window.Booking && typeof window.Booking.load === 'function')
        ? window.Booking.load()
        : {};
    }

    if (typeof options.render === 'function') {
      options.render(currentState());
    }

    // Reveal only now: the page has already decided (synchronously, above)
    // whether to show the empty state, the form, or the summary.
    root.hidden = false;

    if (options.reactive && typeof options.render === 'function') {
      window.addEventListener('naxarly:booking:change', function () {
        options.render(currentState());
      });
    }
  }

  window.BookingLifecycle = { run: run };
})(window);